import React, { Component } from "react";
import PropTypes from "prop-types";

class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.editable) this.fileInput.click();
  }

  render() {
    const { name, onChange, avatar } = this.props;
    let opts = {};
    if (name) opts.name = name;
    if (onChange) opts.onChange = onChange;

    return (
      <div className="upload-widget" onClick={this.handleClick}>
        <img src={!avatar ? null : avatar} alt="" />
        <input
          type="file"
          className="d-none"
          accept="image/x-png,image/jpg,image/jpeg"
          {...opts}
          ref={(ref) => (this.fileInput = ref)}
        />
      </div>
    );
  }
}

ImageUpload.defaultProps = {
  avatar: null,
  editable: true,
};

ImageUpload.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./client/react/Admin/components/ImageUpload/index.jsx